import React, { Component } from "react";
import { Row, Col, Carousel, Button } from "react-bootstrap";
import ProductItemModel from "../models/product-item-model";
import SignalDispatcher from "../utils/signalDispatcher";
import Cart from "../models/cart-model";

interface TicketBoxProps {
    productData: ProductItemModel;
}

interface TicketBoxState {
    productData: ProductItemModel;
    selectedSubProduct?: number;
    selectedSubProductLabel?: string;
    ticketCount: number;
    totalPrice?: number;
    cart?: Array<Cart>;
    translations: Record<string, any>;
}

class TicketBox extends Component<TicketBoxProps, TicketBoxState, ProductItemModel> {
    constructor(props: TicketBoxProps) {
        super(props);
        this.state = {
            productData: this.props.productData,
            ticketCount: 0,
            totalPrice: 0,
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private getPriceHuf(formatted: boolean = false) {
        if (this.state.selectedSubProduct !== undefined && this.state.productData?.subProducts) {
            const subProduct = this.state.productData.subProducts.find(sub => sub.id === this.state.selectedSubProduct);
            const price = subProduct ? subProduct.price_huf : null;
            return formatted && price !== null ? this.formatPrice(price) : price;
        }
        return null;
    }

    private getPriceEur(formatted: boolean = false) {
        if (this.state.selectedSubProduct !== undefined && this.state.productData?.subProducts) {
            const subProduct = this.state.productData.subProducts.find(sub => sub.id === this.state.selectedSubProduct);
            const price = subProduct ? subProduct.price_eur : null;
            return formatted && price !== null ? this.formatPrice(price) : price;
        }
        return null;
    }

    private incrementTicket() {
        this.setState({ ticketCount: this.state.ticketCount + 1 });
    }

    private decrementTicket() {
        this.setState({ ticketCount: this.state.ticketCount > 0 ? this.state.ticketCount - 1 : 0 });
    }

    private addToCart() {
        let cartData = localStorage.getItem('cart');
        if (!cartData) {
            let initialCart: Cart;
            initialCart = {
                cartId: Math.floor(Math.random() * 1000000),
                tickets: [
                    {
                        id: this.state.productData.id, 
                        subProductId: this.state.selectedSubProduct, 
                        quantity: this.state.ticketCount, 
                        price: this.getItemPrice(false),
                        name: this.state.productData.label + (this.state.selectedSubProductLabel ? ' - ' + this.state.selectedSubProductLabel : '')
                    }
                ],
                currency: 'HUF',
                totalPrice: this.getTotalPrice(false)
            };
            localStorage.setItem('cart', JSON.stringify(initialCart));
            SignalDispatcher.emit('addToCart', initialCart);
        }
        else {
            let cartDataObj: Cart = JSON.parse(cartData);
            if (cartDataObj.tickets) {
                const existingTicketIndex = cartDataObj.tickets.findIndex(ticket => ticket.id === this.state.productData.id && ticket.subProductId === this.state.selectedSubProduct);
                if (existingTicketIndex > -1) {
                    cartDataObj.tickets[existingTicketIndex].quantity = (cartDataObj.tickets[existingTicketIndex].quantity as number) + this.state.ticketCount;
                    cartDataObj.tickets[existingTicketIndex].price = this.getItemPrice(false);
                }
                else {
                    cartDataObj.tickets.push({
                        id: this.state.productData.id, 
                        subProductId: this.state.selectedSubProduct, 
                        quantity: this.state.ticketCount, 
                        price: this.getItemPrice(false),
                        name: this.state.productData.label + (this.state.selectedSubProductLabel ? ' - ' + this.state.selectedSubProductLabel : '')
                    });
                }
            }
            else {
                cartDataObj.tickets = [
                    {
                        id: this.state.productData.id, 
                        subProductId: this.state.selectedSubProduct, 
                        quantity: this.state.ticketCount, 
                        price: this.getItemPrice(false),
                        name: this.state.productData.label + (this.state.selectedSubProductLabel ? ' - ' + this.state.selectedSubProductLabel : '')
                    }
                ];
            }
            cartDataObj.totalPrice = cartDataObj.totalPrice + this.getTotalPrice(false);
            localStorage.setItem('cart', JSON.stringify(cartDataObj));
            const updatedCartData = localStorage.getItem('cart');
            const cartDataParsed = updatedCartData ? JSON.parse(updatedCartData) : null;
            const cartDataFinal = cartDataParsed ? cartDataParsed : null;
            const cartDataFinalTyped: Cart = cartDataFinal;
            SignalDispatcher.emit('addToCart', cartDataFinalTyped);
        }
        this.setState({ ticketCount: 0 });
        this.setState({ selectedSubProduct: undefined });
    }

    private formatPrice(price: number) {
        return price !== null ? price.toLocaleString() : '';
    }

    private getTotalPrice(formatted: boolean = false) {
        const priceHuf: any = this.getPriceHuf();
        if (priceHuf !== null) {
            return formatted ? this.formatPrice(priceHuf * this.state.ticketCount) : priceHuf * this.state.ticketCount;
        }
        return 0;
    }

    private getItemPrice(formatted: boolean = false) {
        const priceHuf: any = this.getPriceHuf();
        if (priceHuf !== null) {
            return formatted ? this.formatPrice(priceHuf) : priceHuf;
        }
        return 0;
    }

    render() {
        return (
            <div className="oc-product-box">
                <Row>
                    <Col lg={5} md={5} sm={12} xs={12}>
                        <Carousel controls={false}>
                            { this.state.productData.images.map((img, index) => (
                                <Carousel.Item key={index}>
                                    <figure 
                                        className="oc-product-image" 
                                        style={{ backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                    </figure>
                                </Carousel.Item>
                            )) }
                        </Carousel>
                    </Col>
                    <Col className="oc-product-data" lg={7} md={7} sm={12} xs={12}>
                        <h4>{this.state.productData.label}</h4>
                        <p>{this.state.productData.description}</p>
                        <p>{this.state.translations.filter((item: any) => item.setting_name === 'DURATION')[0].setting_value_text}: </p>
                        <Row className="oc-button-group">
                        { this.state.productData.subProducts?.map((subprod) => (
                            <Col lg={4} md={4} sm={12} xs={12}>
                                <Button 
                                    variant="light" 
                                    className={`oc-subproduct-button ${this.state.selectedSubProduct === subprod.id ? 'active' : ''}`} 
                                    onClick={() => this.setState({ selectedSubProduct: subprod.id, selectedSubProductLabel: subprod.label })}
                                >
                                    {subprod.label}
                                </Button>
                            </Col>
                        ))}
                        </Row>
                        { this.state.selectedSubProduct !== undefined && 
                        <>
                            <p className="oc-product-price">
                                <span>{this.state.translations.filter((item: any) => item.setting_name === 'PRICE')[0].setting_value_text}: </span>
                                <strong className="oc-price oc-text-right">
                                    {this.state.translations.filter((item: any) => item.setting_name === 'ONLY')[0].setting_value_text}&nbsp;
                                    {this.getPriceHuf(true)} {this.state.translations.filter((item: any) => item.setting_name === 'HUF_PERSON')[0].setting_value_text}
                                </strong>
                            </p>
                            <div className="oc-product-qty">
                                <span>{this.state.translations.filter((item: any) => item.setting_name === 'NUMBER_OF_TICKETS')[0].setting_value_text}: </span>
                                <div className="oc-qty-selector oc-text-right">
                                    <Button variant="light" disabled={this.state.ticketCount === 0 ? true : false} className="oc-btn oc-btn-qty" onClick={() => {this.decrementTicket()}}>-</Button>
                                    <input type="text" className="oc-input oc-input-count" value={this.state.ticketCount} readOnly />
                                    <Button variant="light" className="oc-btn oc-btn-qty" onClick={() => {this.incrementTicket()}}>+</Button>
                                </div>
                            </div>
                            { this.state.ticketCount > 0 && 
                            <>
                                <p className="oc-product-total">
                                    <span>{this.state.translations.filter((item: any) => item.setting_name === 'TOTAL_PRICE')[0].setting_value_text}: </span>
                                    <strong className="oc-total-price oc-text-right">{this.getTotalPrice(true)} HUF<br /><small>({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</small></strong>
                                </p>
                                <div className="oc-cta-buttons">
                                    <Button 
                                        variant="light" 
                                        className="oc-btn-add-to-cart" 
                                        onClick={() => this.addToCart()}>{this.state.translations.filter((item: any) => item.setting_name === 'ADD_TO_CART')[0].setting_value_text}</Button>
                                </div>
                            </>
                            }
                        </>
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

export default TicketBox;